module.exports = "<md-card class=\"card-feed-entry\" (click)=\"openLinkInBrowser()\">\r\n  <md-card-title>{{feed.title}}</md-card-title>\r\n  <md-card-subtitle>{{feed.author}} - {{feed.pubDate | date:'dd-MM-yyyy'}}</md-card-subtitle>\r\n  <md-card-content>{{feed.description | stripHtmlTags}}</md-card-content>\r\n</md-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/feed-card/feed-card.component.html
// module id = 132
// module chunks = 4